import { getRoute } from "@utils/route";

export const CAR_INSURANCE_PAGE_URL = '/car-insurance';

export const routeCarInsurancePage = () => getRoute(CAR_INSURANCE_PAGE_URL);
